import { createContext, useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router";
import { Container } from "../../../../common/components/container/Container";
import style from "./style.module.scss";
import "./style.scss";
import { TeamOrderForm } from "./teamOrder/TeamOrderForm";
import { ManifestoForm } from "./manifesto/ManifestoForm";
// import { PlanningForm } from "./planning/PlanningForm";
import { GoBack } from "../../../../common/components/GoBack/GoBack";
import { Loader } from "../../../../common/components/Loader/Loader";
import { FormatDate } from "../../../../utilities/formatDate";
import { HttpStatusCode } from "axios";
import { CommercialOperation } from "../../core/_request";
import { PointingForm } from "./pointing/PointingForm";
// import { ContraryReserve } from "./conntraryReserve/ContraryReserve";
import { OverTimeWork } from "./overtimeWork/OverTimeWork";
import { TimesheetOperations } from "./timesheet/TimesheetOPerations";
import { ExecutionReport } from "./executionReport/ExecutionReport";
import { Shifting } from "./shifting/Shifting";
import { PlanningMainPage } from "./planning/PlanningMainPage";
import { OperationType, OperationTypeContext } from "../../core/_context";
import { ConfrontationPage } from "./confrontation/ConfrontationPage";
import CustomModal from "../../../../common/components/Modal/CustomModal";
import { Checkbox, Form, Modal } from "antd";
import { SimpleInput } from "../../../../common/components/simpleInput/SimpleInput";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import Spinner from "../../../../common/components/Spinner/Spinner";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { UploadInputFile } from "../../../../common/components/Upload/UploadInputFile";
import { API_BASE_URL } from "../../../../utilities/API_CONSTANT";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { createFormData } from "../../../../utilities/formData";
import { IoCheckmarkDoneCircleSharp, IoAddCircleOutline } from "react-icons/io5";
import { MdAddLink } from "react-icons/md";
import { OperationBlock } from "./components/OperationBlock";
import { buildLoads } from "../../core/_buildLoads";
import { Hold } from "./hold/Hold";
import { BsInfoCircle } from "react-icons/bs";

type TabsItemType = {
  key: string;
  title: string;
  component: React.ReactNode;
};
interface OperationContextType {
  initialValue: any;
  handleSetOperationDefaultData: (data: any) => void;
  defaultWorkTimes: any[];
  refreshData: (params?: any) => void;
  filter: any;
  setFilter: (e: any) => void;
}

export const OperationContext = createContext<OperationContextType>({} as any);

export const CreateOperation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  /* const location = useLocation(); */

  const [checked, setChecked] = useState<boolean>(false); 

  const onHandleChecked = () => {
    setChecked((prev: any) => !prev);
  }

  /**
   * CONTEXT FOR PATH
   */

  const location = useLocation();

  const getOperationTypeFromPath = (path: string): OperationType => {
    if (path.includes("/sales-operations")) return "sales";
    if (path.includes("/cabotage")) return "cabotage";
    return "unknown";
  };

  const operationType = getOperationTypeFromPath(location.pathname);

  /**/

  const TABS_ITEM: TabsItemType[] = [
    { key: "team-order", title: "Commande Equipe", component: <TeamOrderForm /> },
    { key: "manifeste", title: "Manifeste", component: <ManifestoForm /> },
    ...(operationType === "sales"
      ? [
          {
            key: "hold",
            title: "Répartition par Cale",
            component: <Hold />,
          },
        ]
      : []),
    { key: "planning", title: "Planification", component: <PlanningMainPage /> }, // { key: "planning", title: "Planification", component: <PlanningForm /> },
    { key: "pointing", title: "Pointage", component: <PointingForm /> },
    /* {
      key: "contradictory-reserve",
      title: "Réserve Contradictoire",
      component: <ContraryReserve />,
    }, */
    {
      key: "performance-report",
      title: "Rapport d'Exécution à Quai",
      component: <ExecutionReport />,
    },
    {
      key: "overtime",
      title: "Travaux Hors Cloche",
      component: <OverTimeWork />,
    },
    { key: "timesheet", title: "Timesheet", component: <TimesheetOperations /> },
    // { key: "details", title: "Détails", component: <OperationDetails /> },
    {
      key: "shifting",
      title: "Shifting & temps d'attente",
      component: <Shifting />,
    },
    {
      key: "confrontation",
      title: "Confrontations",
      component: <ConfrontationPage />,
    },
  ];

  // const searchParams = new URLSearchParams(location.search);
  // const initialTab = searchParams.get("tab") || TABS_ITEM[0].key;

  const searchParams = new URLSearchParams(location.search);

  const tabFromUrl = searchParams.get("tab") || TABS_ITEM[0].key;

  const activeTab = TABS_ITEM.some((item) => item.key === tabFromUrl)
    ? tabFromUrl
    : TABS_ITEM[0].key;

  const [title, setTitle] = useState<string>("");
  // const [activeTab, setActiveTab] = useState<string>(initialTab);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingOperation, setIsLoadingOperation] = useState<boolean>(false);
  const [initialValue, setInitialValue] = useState<any>();
  const [times, setTimes] = useState<Array<any>>([
    FormatDate.DEFAULT_START_TIME,
    FormatDate.DEFAULT_END_TIME,
  ]);
  const [filter, setFilter] = useState<any>({
    // teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
    teamsCreatedAt: null,
  });

  const [showAddEmbarkationButton, setShowAddEmbarkationButton] = useState<boolean>();
  const [showAddDebarkationButton, setShowAddDebarkationButton] = useState<boolean>();
  const [showAddFilesButton, setShowAddFilesButton] = useState<boolean>();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>();
  const [openSuccessModal, setOpenSuccessModal] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);

  const handleShowModal = () => {
    setIsOpenModal((prev: boolean) => !prev);
  }

  const [mscChecked, setMscChecked] = useState(false);

  const [isDebarkation, setIsDebarkation] = useState<boolean>(false);
  const [isEmbarkation, setIsEmbarkation] = useState<boolean>(false);
  const [isBoth, setIsBoth] = useState<boolean>(false);


  /**CONTENT FOR WHEN ADDING MANUAL FORM */

  /* const [sectionErrors, setSectionErrors] = useState<{
      embarkation?: boolean;
      debarkation?: boolean;
    }>({}); */

  const [vehicleExternalParts, setVehicleExternalParts] = useState<any[]>([]);
  const [vehicleInternalParts, setVehicleInternalParts] = useState<any[]>([]);
  const [validationTick, setValidationTick] = useState(0);

  const [form] = Form.useForm();

  const handleSubmitLoads = async (values: any) => {
    try {
      setIsLoadingSubmit(true);

      const dataToPost: any = {
        id: id,
      };

      if ((isDebarkation || isBoth) && values.debarkation) {
        dataToPost.debarkationMovement = {
          loads: buildLoads(
            values.debarkation,
            vehicleExternalParts,
            vehicleInternalParts
          ),
        };
      }

      if ((isEmbarkation || isBoth) && values.embarkation) {
        dataToPost.embarkationMovement = {
          loads: buildLoads(
            values.embarkation,
            vehicleExternalParts,
            vehicleInternalParts
          ),
        };
      }

      const res = await CommercialOperation.updateOperations(dataToPost);

      if (res?.status === HttpStatusCode.Ok) {
        showAddFilesButton && setShowAddFilesButton(false);
        showAddEmbarkationButton && setShowAddEmbarkationButton(false);
        showAddDebarkationButton && setShowAddDebarkationButton(false);
        setIsOpenModal(false);
        refreshData();
      }

    } catch (e) {
      console.log(e);
    } finally {
      setIsLoadingSubmit(false);
    }
  };
    
    const CabotageManifestoFile = () => {
      const STATIC_FILES_NAME = {
        MANIFESTE: "manifestFile",
      };
    
      const [form] = Form.useForm();
    
      const handleSubmitFile = async (values: any) => {
        try {
          setIsLoading(true);
  
          const dataToPost = {
            operation: id,
    
            // Non MSC
            ...(!checked && {
              [STATIC_FILES_NAME.MANIFESTE]:
                values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj,
            }),
          };
  
          const res = await CommercialOperation.addManifestoFiles(createFormData(dataToPost));
  
          if (res.status === HttpStatusCode.Ok) {
            setShowAddFilesButton(false);
            setIsOpenModal(false);
            refreshData();
            setOpenSuccessModal(true);

          setTimeout(() => {
            setOpenSuccessModal(false);
          }, 2000);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      }
    
      return (
        <FormProvider
          Form={Form}
          form={form}
          debug
          onFinish={(values) => {
            handleSubmitFile(values);
          }}
          onFinishFailed={(err) => {
            console.log("err", err);
          }}
        >
          <div className={style.basic__form_first_content}>
            <div className={style.basic__form_first_content_item}>
              <SimpleInput
                Form={Form}
                name={STATIC_FILES_NAME.MANIFESTE}
                label={"Manifeste"}
                rules={[
                  {
                    required: true,
                    message: "Ce champs est obligatoire",
                  },
                ]}
                customInput={
                    <UploadInputFile isExcelOnly />
                }
              />
              <div className={style.basic__link_wrapper}>
                <a
                  href={`${API_BASE_URL}/templates/manifeste.xlsx`} // https://sems.api.livenexx.net/templates/manifeste.xlsx
                  download
                  target="_blank"
                  className={style.basic__link}
                >
                  <AiOutlineCloudDownload className={style.basic__link_icon} />{" "}
                  Télécharger le modèle
                </a>
              </div>
            </div>
            <div className={style.basic__form_first_content_item}></div>
          </div>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>IMPORTER</span>}
            </CustomButton>
          </div>
        </FormProvider>
      );
    };
    

  /** END OF CONTEND FOR WHEN ADDING MANUAL FORM */

  /* BLOC FOR MODAL CONTENT (operation commerciale) */

  const ManifestoFile = ({
    checked,
    setChecked,
  }: {
    checked: boolean;
    setChecked: React.Dispatch<React.SetStateAction<boolean>>;
  }) => {

    const STATIC_FILES_NAME = {
      MANIFESTE: "manifestFile",
      LANDING: "mscDebarkationFile",
      EMPTY_BOARDING: "mscEmptyEmbarkationFile",
      FULL_BOARDING: "mscFullEmbarkationFile",
    };
    
    const [form] = Form.useForm();

    const handleSubmitFile = async (values: any) => {
      try {
        setIsLoading(true);

        const dataToPost = {
          operation: id,
  
          // Non MSC
          ...(!checked && {
              ...(values?.[STATIC_FILES_NAME.MANIFESTE]?.[0]?.originFileObj && {
                [STATIC_FILES_NAME.MANIFESTE]: values[STATIC_FILES_NAME.MANIFESTE][0].originFileObj,
              }),
          }),
  
          // MSC uniquement
          ...(checked && {
            isMsc: 1,
            ...(values?.[STATIC_FILES_NAME.LANDING]?.[0]?.originFileObj && {
              [STATIC_FILES_NAME.LANDING]:
                values[STATIC_FILES_NAME.LANDING][0].originFileObj,
            }),
  
            ...(values?.[STATIC_FILES_NAME.EMPTY_BOARDING]?.[0]
              ?.originFileObj && {
              [STATIC_FILES_NAME.EMPTY_BOARDING]:
                values[STATIC_FILES_NAME.EMPTY_BOARDING][0].originFileObj,
            }),
  
            ...(values?.[STATIC_FILES_NAME.FULL_BOARDING]?.[0]?.originFileObj && {
              [STATIC_FILES_NAME.FULL_BOARDING]:
                values[STATIC_FILES_NAME.FULL_BOARDING][0].originFileObj,
            }),
          }),
        };

        const res = await CommercialOperation.addManifestoFiles(createFormData(dataToPost));

        if (res.status === HttpStatusCode.Ok) {
          setShowAddFilesButton(false);
          setIsOpenModal(false);
          refreshData();

            setOpenSuccessModal(true);

          setTimeout(() => {
            setOpenSuccessModal(false);
          }, 2000);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    return (
      <FormProvider
                Form={Form}
                form={form}
                debug
                onFinish={(values) => {
                  handleSubmitFile(values);
                }}
                onFinishFailed={(err) => {
                  console.log("err", err);
                }}
              >
      <div className={style.basic__form_first_content}>
              { !checked && (
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.MANIFESTE}
                  label={"Résumé commercial"}
                  rules={[
                    {
                      required: true,
                      message: "Ce champs est obligatoire",
                    },
                  ]}
                  customInput={
                      <UploadInputFile isExcelOnly/>
                  }
                />
                <div className={style.basic__link_wrapper}>
                  <a
                    href={`${API_BASE_URL}/templates/resume_commercial.xlsx`}
                    download
                    target="_blank"
                    className={style.basic__link}
                  >
                    <AiOutlineCloudDownload
                      className={style.basic__link_icon}
                    />{" "}
                    Télécharger le modèle
                  </a>
                </div>
              </div>)}
              { checked && (<div className={style.basic__form_first_content_item}>
                
              </div>)}
            </div>
            {/* CHAMPS MSC */}
            
          
            {checked && (
              <div className={style.basic__form_first_content}>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.LANDING}
                  label={"Ficher de débarquement"}
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.EMPTY_BOARDING}
                  label="Fichier d'embarquement vide"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
              <div className={style.basic__form_first_content_item}>
                <SimpleInput
                  Form={Form}
                  name={STATIC_FILES_NAME.FULL_BOARDING}
                  label="Fichier d'embarquement plein"
                  customInput={<UploadInputFile isExcelOnly />}
                />
              </div>
            </div>)}
            <Checkbox className={style.msc_text} checked={checked} onChange={(e) => setChecked(e.target.checked)}>Importer des fichiers MSC</Checkbox>
          {/* BOUTON */}
          <div className={style.basic__footer}>
            <CustomButton
              backgroundColor="#72A4FC"
              className={style.basic__footer_button}
            >
              {isLoadingSubmit ? <Spinner /> : <span>Importer</span>}
            </CustomButton>
          </div>
        </FormProvider>
    );
  }

  /* END OF MODAL CONTENT (operation commerciale) */

  /**
   * MENU ITEMS STYLE
   */

  ///// INDICATEURS DE SCROLL (gauche/droite) /////

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateScrollIndicators = () => {
    if (!tabWrapperRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = tabWrapperRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  };

  useEffect(() => {
    const wrapper = tabWrapperRef.current;
    if (!wrapper) return;

    updateScrollIndicators();
    wrapper.addEventListener("scroll", updateScrollIndicators);

    return () => {
      wrapper.removeEventListener("scroll", updateScrollIndicators);
    };
  }, []);

  ///// LARGEUR ÉGALE POUR TOUS LES ONGLETS /////

  useEffect(() => {
    const items = document.querySelectorAll(`.${style.operation__tab_item}`);
    let maxWidth = 0;

    items.forEach((item) => {
      const width = item.scrollWidth; // largeur réelle du texte
      if (width > maxWidth) maxWidth = width;
    });

    document.documentElement.style.setProperty(
      "--tab-min-width",
      `${maxWidth}px`
    );
  }, []);

  ///// SCROLL FLUIDE ÉLÉMENT PAR ÉLÉMENT /////

  const tabWrapperRef = useRef<HTMLDivElement>(null);
  const scrollIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const scrollOneItem = (direction: "left" | "right") => {
    if (!tabWrapperRef.current) return;

    const container = tabWrapperRef.current;
    const firstItem = container.querySelector(
      `.${style.operation__tab_item}`
    ) as HTMLElement;
    if (!firstItem) return;

    const itemWidth = firstItem.offsetWidth + 10; // including gap

    // Initial position
    const { scrollLeft, scrollWidth, clientWidth } = container;

    // Stop scolling when reaching edge
    if (direction === "left" && scrollLeft <= 0) {
      stopScroll();
      return;
    }
    if (direction === "right" && scrollLeft + clientWidth >= scrollWidth) {
      stopScroll();
      return;
    }

    container.scrollBy({
      left: direction === "left" ? -itemWidth : itemWidth,
      behavior: "smooth",
    });

    // Updtate indicators
    updateScrollIndicators();
  };

  const startScroll = (direction: "left" | "right") => {
    if (scrollIntervalRef.current) clearInterval(scrollIntervalRef.current);

    scrollIntervalRef.current = setInterval(() => {
      scrollOneItem(direction);
    }, 200); // scroll per items each 0.2s
  };

  const stopScroll = () => {
    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
  };

  /**
   * END MENU ITEMS STYLE
   */
  useEffect(() => {
    if (id) {
      fetchTeamOrder(+id);
    }
  }, [id]);

  /* useEffect(() => {
    setActiveTab(initialTab);
  }, [location.search]); */

  const handleChangeActiveTab = (key: string) => {
    navigate(`?tab=${key}`);
  };

  /* const getWorkTime = async (
    id: number,
    workId: number,
    filterParams?: any
  ) => {
    try {
      setIsLoading(true);

      const res = await WorkCalendarService.getWorkShedule(workId);
      if (res?.status === HttpStatusCode.Ok) {
        setTimes([res?.data?.startTime, res?.data?.endTime]);
        fetchTeamOrder(id, filterParams);
        // form.setFieldsValue(formatedData);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }; */

  const fetchTeamOrder = async (id: number, params?: any) => {
    try {
      setIsLoadingOperation(true);
      const res = await CommercialOperation.getOneOperation(id, params);

      if (res?.status === HttpStatusCode.Ok) {
        setTitle(res?.data?.referenceLabel);

        setInitialValue(
          formatData({
            ...res?.data,
          })
        );

        setShowAddEmbarkationButton(res?.data?.waitingEmbarkation)
        setShowAddDebarkationButton(res?.data?.waitingDebarkation)
        setShowAddFilesButton(res?.data?.operationState.id === "AWAITING_MANIFESTE")
        setIsEmbarkation(res?.data?.operationType?.id === "EMBARKATION")
        setIsDebarkation(res?.data?.operationType?.id === "DEBARKATION")
        setIsBoth(res?.data?.operationType?.id === "EMBARKATION_DEBARKATION")
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingOperation(false);
    }
  };

  const formatData = (data: any) => {
    const formattedData = {
      ...data,
      holdsValueLength: data?.holds?.length,
      receiptRequestAt: data?.receiptRequestAt
        ? FormatDate.dayjsFormat(data?.receiptRequestAt)
        : null,
      estimatedArrivalAt: data?.estimatedArrivalAt
        ? FormatDate.dayjsFormat(data?.estimatedArrivalAt)
        : null,
      startAt: data?.startAt ? FormatDate.dayjsFormat(data?.startAt) : null,
      endAt: data?.endAt ? FormatDate.dayjsFormat(data?.endAt) : null,
      teamOrderFile: data?.teamOrderFile
        ? {
            label: data?.teamOrderFile?.basename,
            value: data?.teamOrderFile?.["@id"],
          }
        : null,
      arrivalNoticeFile: data?.arrivalNoticeFile
        ? {
            label: data?.arrivalNoticeFile?.basename,
            value: data?.arrivalNoticeFile?.["@id"],
          }
        : null,
      embarkationPlanFile: data?.embarkationPlanFile
        ? {
            label: data?.embarkationPlanFile?.basename,
            value: data?.embarkationPlanFile?.["@id"],
          }
        : null,
      debarkationPlanFile: data?.debarkationPlanFile
        ? {
            label: data?.debarkationPlanFile?.basename,
            value: data?.debarkationPlanFile?.["@id"],
          }
        : null,
      customer: data?.customer
        ? {
            label: data?.customer?.name,
            value: data?.customer?.[`@id`],
          }
        : null,
      customerCategory: data?.customer
        ? {
            label: data?.customer?.customerCategory?.name,
            value: data?.customer?.customerCategory?.[`@id`],
          }
        : null,
      operationType: data?.operationType
        ? {
            label: data?.operationType?.name,
            value: data?.operationType?.["@id"],
          }
        : null,
      operationShifting: data?.operationShifting
        ? {
            label: data?.operationShifting?.name,
            value: data?.operationShifting?.["@id"],
          }
        : null,
      teamsDockside: data?.teamsDockside?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart)
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd)
          } : {}
        ),
        ...(item?.assignmentLocation
          ? {
              assignmentLocation: {
                label: item?.assignmentLocation?.name,
                value: item?.assignmentLocation?.["@id"],
              },
            }
          : {}),
      })),
      teamsOnBoard: data?.teamsOnBoard?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart)
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd)
          } : {}
        ),
      })),
      teamsStorage: data?.teamsStorage?.map((item: any) => ({
        ...item,
        ...(item.teamShiftStart ? 
          {
            teamShiftStart: FormatDate.dayjsTimeFormat(item.teamShiftStart)
          } : {}
        ),
        ...(item.teamShiftEnd ? 
          {
            teamShiftEnd: FormatDate.dayjsTimeFormat(item.teamShiftEnd)
          } : {}
        ),
      })),
    };

    return formattedData;
  };

  const handleSetOperationDefaultData = (value: any) => {
    fetchTeamOrder(value?.id, filter);
  };

  const refreshData = (params?: any) => {
    fetchTeamOrder(id as any, params ?? filter);
  };

  const onRedirect = () => {
    navigate(`../detail/${id}`)
  }

  return (
    <OperationTypeContext.Provider value={operationType}>
      <OperationContext.Provider
        value={{
          initialValue,
          handleSetOperationDefaultData,
          defaultWorkTimes: times,
          refreshData,
          filter,
          setFilter,
        }}
      >
        <Loader isLoading={isLoading || isLoadingOperation} />
        <div className={style.operation}>
          <GoBack
            uri={
              operationType === "sales"
                ? "/app/operations/sales-operations"
                : "/app/operations/cabotage"
            }
          />
          <div className={style.operation__header_wrapper}>
            <span className={style.operation__header}>{title}</span>
            <div className={style.buttonWrapper}>
            {showAddEmbarkationButton && (
              <div className={style.buttonAdd__custom} onClick={handleShowModal} >
                <IoAddCircleOutline size={18}/>
                  Ajouter embarquement
              </div>
            )}
            {showAddDebarkationButton && (
              <div className={style.buttonAdd__custom} onClick={handleShowModal} >
                <IoAddCircleOutline size={18}/>
                  Ajouter débarquement
              </div>
            )}
            {showAddFilesButton && (
              <div className={style.buttonAdd__custom} onClick={handleShowModal} >
                <MdAddLink size={18}/>
                Importer manifeste
              </div>
            )}
            <div style={{gap: "9px"}} className={style.buttonLike} onClick={onRedirect}>
              <BsInfoCircle size={16} />
              Détails
            </div>
          </div>
          </div>
          <div className={style.operation__tab_wrapper_container}>
            {canScrollLeft && (
              <div
                className={`${style.operation__scroll_zone} ${style.operation__scroll_zone_left}`}
                onMouseEnter={() => startScroll("left")}
                onMouseLeave={stopScroll}
              />
            )}
            {canScrollRight && (
              <div
                className={`${style.operation__scroll_zone} ${style.operation__scroll_zone_right}`}
                onMouseEnter={() => startScroll("right")}
                onMouseLeave={stopScroll}
              />
            )}

            <div ref={tabWrapperRef} className={style.operation__tab_wrapper}>
              {TABS_ITEM.map((item: TabsItemType) => (
                <span
                  className={`${style.operation__tab_item} ${
                    activeTab === item.key
                      ? style.operation__tab_item_active
                      : ""
                  }`}
                  key={item.key}
                  onClick={() => handleChangeActiveTab(item.key)}
                >
                  {item.title}
                </span>
              ))}
            </div>
          </div>

          <Container>
            {TABS_ITEM.find((item) => item.key === activeTab)?.component}
          </Container>
        </div>
        <CustomModal
          isOpen= {isOpenModal}
          hanldeCloseModal={handleShowModal}
          title={`${operationType === "sales" ? "Importer manifeste" : showAddFilesButton ? "Ajouter manifeste" : `Ajouter un ${showAddEmbarkationButton ? "embarquement" : "débarquement"}`}`}
          width= {operationType === "sales" ? "68%" : "85%"}
          maxHeight="500px"
        >
          {operationType === "sales" ? (
            <ManifestoFile checked={mscChecked} setChecked={setMscChecked}/>
          )
          : (
            <>
              {showAddFilesButton ? (
                <>
                  <Checkbox className={style.msc_text} checked={checked} onClick={onHandleChecked}>Remplir manuellement</Checkbox>
                  {checked ? (
                    <Form
                     style={{marginTop: "20px"}}
                      form={form}
                      onFinish={handleSubmitLoads}
                      onFieldsChange={() => {
                        setValidationTick((prev) => prev + 1);
                      }}
                      onFinishFailed={(err) => {
                        console.log("err", err);
                        setValidationTick((prev) => prev + 1);
                      }}
                    >
                    {(isDebarkation || isBoth) && (
                      <OperationBlock
                        title="DÉBARQUEMENT"
                        prefix="debarkation"
                        form={form}
                        //sectionErrors={sectionErrors}
                        validationTick={validationTick}
                        setVehicleExternalParts={setVehicleExternalParts}
                        setVehicleInternalParts={setVehicleInternalParts}
                      />
                    )}

                    {(isEmbarkation || isBoth) && (
                      <OperationBlock
                        title="EMBARQUEMENT"
                        prefix="embarkation"
                        form={form}
                        // sectionErrors={sectionErrors}
                        validationTick={validationTick}
                        setVehicleExternalParts={setVehicleExternalParts}
                        setVehicleInternalParts={setVehicleInternalParts}
                      />
                    )}
                      <div className={style.basic__footer}>
                        <CustomButton
                          type="submit"
                          backgroundColor="#72A4FC"
                          className={style.basic__footer_button}
                        >
                          {isLoadingSubmit ? <Spinner /> : <span>AJOUTER MANIFESTE</span>}
                        </CustomButton>
                      </div>
                    </Form>
                  ) : (
                    <CabotageManifestoFile />
                  )}
                </>
              ) : (
                  <>
                  <Form
                    form={form}
                    onFinish={handleSubmitLoads}
                    onFieldsChange={() => {
                      setValidationTick((prev) => prev + 1);
                    }}
                    onFinishFailed={(err) => {
                      console.log("err", err);
                      setValidationTick((prev) => prev + 1);
                    }}
                  >
                    <OperationBlock
                      prefix={showAddEmbarkationButton ? "embarkation" : "debarkation"}
                      form={form}
                      // sectionErrors={sectionErrors}
                      validationTick={validationTick}
                      setVehicleExternalParts={setVehicleExternalParts}
                      setVehicleInternalParts={setVehicleInternalParts}
                    />
                    <div className={style.basic__footer}>
                      <CustomButton
                        backgroundColor="#72A4FC"
                        className={style.basic__footer_button}
                        onClick={() => {}}
                      >
                        {isLoadingSubmit ? <Spinner /> : <span>{`Ajouter ${showAddEmbarkationButton ? "l'embarquement" : "le débarquement"}`}</span>}
                      </CustomButton>
                    </div>
                  </Form>
                  </>                
              )}
            </>
          )
          }
        </CustomModal>
        <Modal
          open={openSuccessModal}
          centered
          width={300}
          footer={null}
          closable={false}
          styles={{
            body: { padding: 0 },
            content: { padding: 0 },
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              height: "100%",
              padding: "20px",
              backgroundColor: "#f6fff8",
              borderRadius: "12px",
              border: "1px solid #c3e6cb",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            }}
          >
            <IoCheckmarkDoneCircleSharp
              size={100}
              style={{
                color: "#28a745",
                marginBottom: "20px",
              }}
            />
            <p
              style={{
                margin: 0,
                fontSize: "1rem",
                fontWeight: "600",
                color: "#155724",
              }}
            >
              Manifeste importé avec succès !
            </p>
          </div>
        </Modal>
      </OperationContext.Provider>
    </OperationTypeContext.Provider>
  );
};
